{
  "settings.title": "Settings",
  "settings.tabs": "Settings sections",
  "settings.team.tab": "Team",
  "settings.team.col_member": "Member",
  "settings.team.col_role": "Role",
  "settings.team.col_review": "Review languages",
  "settings.team.col_access": "Access",
  "settings.team.col_open": "Open",
  "settings.team.col_permission": "Permission",
  "settings.team.you": "(you)",
  "settings.team.no_review": "None",
  "settings.team.permanent": "Permanent member",
  "settings.team.support": "Support",
  "settings.team.support_expired": "Expired",
  "settings.team.expires_at": "Until {date}",
  "settings.team.expired_at": "Expired on {date}",
  "settings.team.support_title": "{count, plural, one {# person with temporary support access} other {# people with temporary support access}}",
  "settings.team.support_body": "Support access ends automatically on the expiry date. Actions are in the audit log, as for every member.",
  "settings.team.matrix": "What each role may do",
  "settings.team.matrix_body": "The same permission matrix the server checks for every action.",
  "settings.team.allowed": "Allowed",
  "settings.team.not_allowed": "Not allowed",
  "settings.team.empty_title": "No team members",
  "settings.team.empty_body": "This organisation has no members yet.",
  "settings.team.saved": "{name} updated",
  "settings.team.save": "Save",
  "settings.team.review_hint": "This member approves translations in these languages.",
  "settings.team.review_hint_no_right": "The {role} role does not approve translations; review languages only count with a role that does.",
  "settings.team.last_owner_title": "Only owner",
  "settings.team.last_owner_body": "Make someone else owner first; then this role can change.",
  "settings.team.no_rights_title": "Read only",
  "settings.team.no_rights_body": "Only owners and administrators change roles and review languages.",
  "settings.team.support_readonly_title": "Temporary support access",
  "settings.team.support_readonly": "Reason: {reason}. You do not change this access here; it ends by itself.",
  "settings.team.conflict_title": "Changed in the meantime",
  "settings.team.conflict_body": "Someone else changed {name} while you were working.",
  "settings.team.conflict_now": "Saved now",
  "settings.team.conflict_yours": "Your choice",
  "settings.team.conflict_reload": "Load latest",
  "settings.team.conflict_keep": "Save my choice",
  "settings.team.error.last_owner": "The last owner keeps the owner role. Make someone else owner first.",
  "settings.team.error.support_member": "You do not change support access through the team; it ends by itself.",
  "settings.team.role_hint.owner": "Everything, including team, export and the owner role",
  "settings.team.role_hint.admin": "Everything except granting the owner role",
  "settings.team.role_hint.agent": "Listings, images, texts, contacts and dry runs",
  "settings.team.role_hint.editor": "Listings, images and texts; contacts read only",
  "settings.team.role_hint.reviewer": "Write and approve translations in their review languages",
  "settings.team.role_hint.viewer": "View only",
  "settings.perm.property.read": "View listings",
  "settings.perm.property.write": "Edit listings",
  "settings.perm.property.publish": "Record property rights",
  "settings.perm.media.write": "Manage images",
  "settings.perm.localization.write": "Write translations",
  "settings.perm.localization.review": "Approve translations",
  "settings.perm.import.run": "Start dry runs",
  "settings.perm.import.apply": "Apply imports and manage sources",
  "settings.perm.channel.manage": "Manage portals",
  "settings.perm.crm.read": "View contacts and enquiries",
  "settings.perm.crm.write": "Edit contacts and enquiries",
  "settings.perm.site.publish": "Publish and roll back the website",
  "settings.perm.site.withdraw": "Emergency withdrawal",
  "settings.perm.ai.use": "Use the AI assistant",
  "settings.perm.settings.manage": "Settings and full export",
  "settings.perm.team.manage": "Manage team",
  "settings.perm.audit.read": "Read audit log",
  "settings.audit.tab": "Audit log",
  "settings.audit.col_time": "Time",
  "settings.audit.col_action": "Event",
  "settings.audit.col_actor": "By",
  "settings.audit.col_object": "Object",
  "settings.audit.object_type": "Object type",
  "settings.audit.all_types": "All types",
  "settings.audit.clear": "Clear filters",
  "settings.audit.filter_object": "Only this object",
  "settings.audit.filter_object_id": "Only events for object {id}",
  "settings.audit.open_object": "Open",
  "settings.audit.empty_title": "No events yet",
  "settings.audit.empty_body": "Changes appear here with the time and who made them.",
  "settings.audit.empty_filtered_title": "Nothing found",
  "settings.audit.empty_filtered_body": "No events for this filter.",
  "settings.audit.no_rights_title": "No access to the audit log",
  "settings.audit.no_rights_body": "Only owners and administrators read the audit log.",
  "settings.audit.search": "Search the audit log",
  "settings.audit.search_placeholder": "Details or object ID",
  "settings.audit.area_label": "Area",
  "settings.audit.all_areas": "All areas",
  "settings.audit.all_actors": "Everyone",
  "settings.audit.object_filter_clear": "Clear filter on object {id}",
  "settings.audit.area.properties": "Listings",
  "settings.audit.area.localization": "Languages",
  "settings.audit.area.crm": "Clients",
  "settings.audit.area.imports": "Imports",
  "settings.audit.area.channels": "Portals",
  "settings.audit.area.website": "Website",
  "settings.audit.area.team": "Team",
  "settings.audit.area.ai": "AI",
  "settings.object.property": "Property",
  "settings.object.site": "Website",
  "settings.object.connector_account": "Portal channel",
  "settings.object.import_run": "Import run",
  "settings.object.import_source": "Import source",
  "settings.object.localized_revision": "Translation",
  "settings.object.content_unit": "Text",
  "settings.object.lead": "Enquiry",
  "settings.object.contact": "Contact",
  "settings.object.task": "Task",
  "settings.object.shortlist": "Shortlist",
  "settings.object.media_asset": "Image",
  "settings.object.appointment": "Appointment",
  "settings.object.locale": "Language",
  "settings.object.shortlist_share": "Shared shortlist",
  "settings.object.tenant": "Organisation",
  "settings.object.term_entry": "Term",
  "settings.object.membership": "Team member",
  "settings.export.tab": "Export",
  "settings.export.title": "Full export",
  "settings.export.lead": "All data of {org} in one JSON file, for switching providers or archiving.",
  "settings.export.format": "JSON, format bres_export_v1",
  "settings.export.download": "Download export",
  "settings.export.included_title": "Included",
  "settings.export.excluded_title": "Not included",
  "settings.export.included.listings": "Properties, offers, private data and locked fields",
  "settings.export.included.rights": "Rights per property and channel",
  "settings.export.included.media": "Image records and image rights",
  "settings.export.included.texts": "Texts, translations with review status, terms and translation memory",
  "settings.export.included.crm": "Contacts, consents, enquiries, notes, tasks, appointments, buyer briefs and shortlists",
  "settings.export.included.imports": "Import sources and external IDs",
  "settings.export.included.sites": "Organisation, areas, websites, languages and published paths",
  "settings.export.excluded.passwords": "Passwords, sessions and two-factor codes",
  "settings.export.excluded.secrets": "Keys and secrets of integrations and portals",
  "settings.export.excluded.media_files": "The image files themselves (records only)",
  "settings.export.excluded.audit": "Audit log",
  "settings.export.excluded.jobs": "Background jobs, builds and portal feeds",
  "settings.export.done": "Export downloaded",
  "settings.export.summary": "{size}, {tables} tables, {rows} rows, including {properties} properties and {contacts} contacts.",
  "settings.export.private_title": "Contains private data",
  "settings.export.private_body": "Owners, addresses, commissions and client contact details are in this file. Store it encrypted and do not send it by email.",
  "settings.export.no_rights_title": "No access to the export",
  "settings.export.no_rights_body": "Only owners and administrators can export all data.",
  "settings.diagnostics.tab": "Diagnostics",
  "settings.diagnostics.jobs": "Background jobs",
  "settings.diagnostics.refresh": "Refresh",
  "settings.diagnostics.col_kind": "Type",
  "settings.diagnostics.col_status": "Status",
  "settings.diagnostics.col_count": "Count",
  "settings.diagnostics.col_error": "Last error",
  "settings.diagnostics.no_jobs": "No background jobs yet.",
  "settings.diagnostics.notifications": "Email notifications",
  "settings.diagnostics.no_notifications": "No notifications sent yet.",
  "settings.diagnostics.versions": "Versions",
  "settings.diagnostics.code": "Code",
  "settings.diagnostics.api": "API",
  "settings.diagnostics.node": "Node.js",
  "settings.diagnostics.database": "Database",
  "settings.diagnostics.ai": "AI provider",
  "settings.diagnostics.problems": "{count, plural, one {# job or notification failed} other {# jobs or notifications failed}}",
  "settings.diagnostics.problems_body": "Failed jobs are retried; jobs that gave up need action. Check the last error per type.",
  "settings.diagnostics.dev_title": "Development tools",
  "settings.diagnostics.dev_body": "Only visible in the local development environment.",
  "settings.diagnostics.chaos_label": "Simulate mail outage",
  "settings.diagnostics.chaos_active": "Sending to the test mailbox fails now. Notifications are retried once you turn this off.",
  "settings.diagnostics.chaos_on": "Mail outage on",
  "settings.diagnostics.chaos_off": "Mail outage off",
  "settings.diagnostics.mailpit": "Open test mailbox",
  "settings.job_status.queued": "Queued",
  "settings.job_status.running": "Running",
  "settings.job_status.succeeded": "Succeeded",
  "settings.job_status.failed": "Failed, will retry",
  "settings.job_status.dead": "Gave up",
  "settings.job_status.cancelled": "Cancelled",
  "settings.notification_status.pending": "Waiting",
  "settings.notification_status.sent": "Sent",
  "settings.notification_status.failed": "Failed",
  "settings.notification_status.dead": "Gave up",
  "settings.object.blog_post": "Blog article",
  "settings.object.blog_source": "Blog source",
  "settings.object.ai_feature": "AI feature",
  "settings.object.ai_job": "AI task",
  "settings.object.chat_conversation": "Chat conversation",
  "settings.object.chat_knowledge": "Chat knowledge"
}
